import style from "modules/SelectionOfPsychologists/components/Card/AudioMark/audioMark.module.scss"
import { Icon } from "components"

export function AudioMark() {
    return (
        <div className={style.container}>
            <Icon type="play-circle-outline" size="24" />
        </div>
    )
}
